<template>
  <div class="vx-row">
    <div class="vx-col w-full md:w-1/2">
      <vs-card>
        <div slot="header">
          <div class="vx-row text-center m-2">
            <h3 class="w-full text-center">Sedang Dilayani</h3>
          </div>
        </div>
        <div class="flex flex-col px-5">
          <item-list-customer
            v-for="(item, index) in queueCounterList"
            :key="index"
            :item="item.on_service"
            :index="index"
          >
            <div
              slot="action"
              @click="openCounter(item)"
              class="text-3xl flex flex-col justify-center"
            >
              <vs-chip class="float-right cursor-pointer" color>
                <vs-avatar v-if="item.on_service" :src="item.on_service.avatar" />
                <vs-avatar v-else />
                <span class="text-primary">{{ item.counter_name }}</span>
              </vs-chip>
            </div>
            <div slot="item-empty">
              <div class="flex items-center">
                <div class="pr-3">
                  <vs-avatar size="large" class="text-lg" />
                </div>
                <div>
                  <div class="text-lg font-semibold flex items-center">
                    <div class="mr-2">Tersedia</div>
                  </div>
                  <div class="text-lg font-medium flex items-center">
                    <div class="mr-2">Siap memanggil antrian</div>
                  </div>
                </div>
              </div>
            </div>
          </item-list-customer>
        </div>
      </vs-card>
    </div>
    <div class="vx-col w-full md:w-1/2">
      <vs-card>
        <div slot="header">
          <div class="vx-row text-center m-2">
            <h3 class="w-full text-center">Daftar Antrian</h3>
          </div>
        </div>
        <div class="flex flex-col px-5">
          <!-- Customer -->
          <div v-if="menuType == 'customer'">
            <div
              class="vx-row border-t-0 border-l-0 border-r-0 border-b border-solid border-grey-light py-3 my-3"
            >
              <h5>
                <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-clock" />
                {{ cluster.start_time }} - {{ cluster.end_time }}
              </h5>
            </div>
            <item-list-customer
              v-for="(item, index) in queueList"
              :key="index"
              :item="item"
              :index="index"
              :isSelf="user.id == item.customer_id"
            ></item-list-customer>
          </div>
          <!-- Petugas -->
          <div v-else>
            <div v-for="(item,index) in queueList" :key="index">
              <div
                class="vx-row border-t-0 border-l-0 border-r-0 border-b border-solid border-grey-light py-3 my-3"
              >
                <h5>
                  <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-clock" />
                  {{item.start_time}} - {{item.end_time}}
                </h5>
              </div>
              <span
                class="text-lg text-center"
                v-if="item.data.length == 0"
              >Antrian pada jam ini kosong</span>
              <item-list-customer
                v-for="(item, index) in item.data"
                :key="index"
                :item="item"
                :index="index"
                type="secure"
              ></item-list-customer>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
    <popup-counter-detail :active.sync="popupCounter" :counter="counterDetail" />
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";
import PopupCounterDetail from "@/components/queue/PopupCounterDetail.vue";
import ItemListCustomer from "@/components/queue/ItemListCustomer.vue";

export default {
  components: {
    vSelect,
    PopupCounterDetail,
    ItemListCustomer
  },
  props: {
    serviceId: {
      required: true
    },
    clusterId: {
      required: false,
      default: null
    },
    menuType: {
      required: false,
      default: "customer"
    },
    bus: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      color: ["primary", "warning", "success"],
      popupCounter: false,
      queueList: [],
      queueCounterList: [],
      counterDetail: [],
      cluster: []
    };
  },
  computed: {
    ...mapGetters(["userAgent", "guestTypes"]),
    user() {
      return this.$store.state.AppActiveUser;
    }
  },
  mounted() {
    this.getListQueue();
    this.bus.$on("reloadQueue", () => {
      this.getListQueue();
    });
  },
  methods: {
    getListQueue() {
      this.$http
      .get(
        this.menuType == "customer"
          ? `/app/queue/active-queue/list-queue/${this.serviceId}/${this.clusterId}`
          : `/app/secure/counter-process/list-queue/${this.serviceId}`
      )
      .then(r => {
        this.queueList = r.data.data.queue_list;
        this.queueCounterList = r.data.data.counter_list;
        this.cluster = r.data.data.cluster;
        this.createMapper(r.data.data.queue_list);
        this.bus.$emit("counterList", r.data.data.counter_list);
      })
      .catch(e => {
        this.parseError(e);
      });
    },
    openCounter(item) {
      this.counterDetail = item;
      this.popupCounter = true;
    },
    createMapper(data) {
      let queues = [];
      if (this.menuType == "customer") {
        data.map(queue => {
          if (
            ["waiting", "on_service", "calling"].includes(
              queue.status
            )
          ) {
            queues.push(queue);
          }
        });
      } else {
        data.map(cluster => {
          cluster.data.map(queue => {
            if (
              ["waiting", "on_service", "calling"].includes(
                queue.status
              )
            ) {
              queues.push(queue);
            }
          });
        });
      }
      this.$emit("callData", queues);
    }
  }
};
</script>
